import { CommonModule } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ConfirmRedirectDialogData } from '../confirm-redirect-popup/confirm-redirect-popup.component';


@Component({
  selector: 'app-edit-claimchart-popup',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatProgressSpinner, FormsModule, MatIconModule],
  template:`
  <div class="popup-header">

<h2>{{claimChartTitle}}</h2>
<div class="popup-buttons">
    <button class="cross-btn" (click)="onSave()"><i class="material-icons">close</i></button>
</div>
</div>
<div class="editable-cell-wrapper" [class.expanded]="true">
                        <div class="editable-cell-content pseudo-editor" contenteditable="true" id="htmlDataSubPopup" [innerHTML]="getHTMLData()" >
                        </div>
                        </div>
                        
`,
  styleUrls: ['./edit-claimchart-popup.component.css'],
})
export class SubEditClaimchartPopupComponent {
    HTMLData: string = '';
    isExpanded: { claim: boolean; infringement: boolean }[] = [];
    claimChartTitle: string = 'Edit Claim Chart';
    constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      private dialogRef: MatDialogRef<SubEditClaimchartPopupComponent>
    ) {}
  
    ngOnInit(): void {
        this.HTMLData=this.data.HTMLData;
    }

    getHTMLData(): string {
        return this.HTMLData;
    }

    onCancel(){
        this.dialogRef.close();
    }
    onSave() {
        let htmlDataElement = document.getElementById('htmlDataSubPopup');
        if (htmlDataElement) {
            this.HTMLData = htmlDataElement.innerHTML;
        }
        console.log(this.HTMLData);
        console.log(htmlDataElement)
        this.dialogRef.close(htmlDataElement);
    }
}